import { createEvent, sample } from 'effector'
import { CreateAccountForm, CreateAccountRequest } from './types'
import { restore } from 'effector'
import { fx } from '../../../../../../libs'
import { Error } from '../../../../../gateway/edit/types'
export const setAccount = createEvent<CreateAccountForm>()

export const setCreateAccountError = createEvent<Error>()

export const $accountForm = restore(setAccount, {
  clientId: '',
  currency: '',
  fixRateValue: '0',
  isSwapFree: false,
  leverage: '',
  accountPlatform: '',
  tariff: '',
})

export const $errorCreateAccount = restore(setCreateAccountError, {
  message: '',
  code: 0,
})

export const creatAccount = fx<CreateAccountRequest, void>({
  method: 'POST',
  url: '/account',
})

export const submitCreateAccount = createEvent<CreateAccountRequest>()

sample({
  clock: submitCreateAccount,
  fn: (account) => {
    return {
      url: `/account`,
      body: { ...account },
    }
  },
  target: creatAccount,
})

sample({
  clock: creatAccount.doneData,
  fn: () => {
    return {
      clientId: '',
      currency: '',
      fixRateValue: '0',
      isSwapFree: false,
      leverage: '',
      accountPlatform: '',
      tariff: '',
    }
  },
  target: [setAccount],
})

sample({
  clock: creatAccount.failData,
  fn: (failData) => {
    return { message: failData.body.message, code: failData.status }
  },
  target: [setCreateAccountError],
})
